import { globalAppState } from './notes-state'
import { persistData, loadData } from './persist'
import  { newNote } from './data/notes'
import type { AppState, Note } from './types/index'

import './notes-list'
import './notes-list-item'
import './single-note'
import './notes-state'


global css html
	ff:'Poppins', sans-serif
	body
		m:0 p:0 c:cooler8

tag app
	css 
		.container
			d:flex 
			fld:column fld@md:row

		notes-list
			max-width:100% width@md:300px
			pos:absolute l:0 t:0 b:0 ofy:scroll
		single-note
			w:100%
			ml:300px

	stateLoaded = false

	def mount
		const storedState\AppState = await loadData 'appState'
		if storedState
			state = storedState
		else
			state = globalAppState
		stateLoaded = true


	def selectNote e\CustomEvent
		# first save previous note ?? need most current changes to data
		const note = e.detail
		state.notes.forEach(do(n) n.selected = false)
		note.selected = true
		state.currentNote = note


	
	def saveNote e\CustomEvent
		const note = e.detail
		state.notes = state..notes.map(do(n) n.id === note.id ? note : n)
		state.currentNote = note
		persistData state
	

	def addNewNote
		state.notes.forEach(do(n) n.selected = false)
		const emptyNote = newNote()
		state.notes = [emptyNote, ...state.notes]
		state.currentNote = emptyNote



	<self>
		<div .container>
			if stateLoaded
				<notes-list @selectNote=selectNote @addNewNote=addNewNote>
				<single-note @saveNote=saveNote>
			else
				"loading..."

imba.mount <app>
